import type { FC } from "react";
import styles from "./RotateDeviceOverlay.module.scss";

/**
 * Mounted once at the app root (main.tsx), outside Redux/Router/Query, so
 * it covers every page for free — no per-page wiring needed. Visibility is
 * pure CSS (a media query in the .module.scss), not JS/resize-listener
 * driven: it's always in the DOM, hidden by default, and the browser alone
 * toggles it on/off as the device rotates. Zero re-render cost either way.
 */
export const RotateDeviceOverlay: FC = () => {
  return (
    <div className={styles.overlay}>
      <svg
        className={styles.icon}
        width="56"
        height="56"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="7"
          y="2"
          width="10"
          height="16"
          rx="2"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <line
          x1="10"
          y1="16.5"
          x2="14"
          y2="16.5"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M20 12a8 8 0 0 1-3 6.2"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M18.5 15.8 20 18.7l2.3-1.9"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <p className={styles.message}>Please rotate your device to see content</p>
    </div>
  );
};

export default RotateDeviceOverlay;
